import { SelectItem } from 'app/shared/models/select-item.type';
import {
	VehicleInsuranceRecordCategoryEnum,
	VehicleInsuranceCoverageTypeEnum,
	VehicleInsuranceStatusEnum,
	vehicleInsuranceStatusToColor,
	VehicleInsurancePremiumPeriodEnum,
} from '@splitsecondconnect/ultramarine-shared';

import { FEATURES } from '../../../../core/features/features';

export const VEHICLE_INSURANCE_STATUSES: SelectItem<VehicleInsuranceStatusEnum>[] =
	[
		{
			value: VehicleInsuranceStatusEnum.ACTIVE,
			displayValue: 'vehicle-insurances|status|active',
			pillColor: vehicleInsuranceStatusToColor(
				VehicleInsuranceStatusEnum.ACTIVE,
			),
		},
		{
			value: VehicleInsuranceStatusEnum.PENDING,
			displayValue: 'vehicle-insurances|status|pending',
			pillColor: vehicleInsuranceStatusToColor(
				VehicleInsuranceStatusEnum.PENDING,
			),
		},
		{
			value: VehicleInsuranceStatusEnum.EXPIRED,
			displayValue: 'vehicle-insurances|status|expired',
			pillColor: vehicleInsuranceStatusToColor(
				VehicleInsuranceStatusEnum.EXPIRED,
			),
		},
	];

export const VEHICLE_INSURANCE_CATEGORIES: SelectItem<VehicleInsuranceRecordCategoryEnum>[] =
	[
		{
			value: VehicleInsuranceRecordCategoryEnum.VEHICLE,
			displayValue: 'vehicle-insurances|record-category|vehicle',
			disabled: !FEATURES.vehicles,
		},
	];

export const VEHICLE_INSURANCE_COVERAGE_TYPES: SelectItem<VehicleInsuranceCoverageTypeEnum>[] =
	[
		{
			value: VehicleInsuranceCoverageTypeEnum.COMPREHENSIVE,
			displayValue: 'vehicle-insurances|record-category|comprehensive',
			disabled: !FEATURES.vehicleInsurances,
		},
		{
			value: VehicleInsuranceCoverageTypeEnum.COMPREHENSIVE_PLUS,
			displayValue: 'vehicle-insurances|record-category|comprehensive-plus',
			disabled: !FEATURES.vehicleInsurances,
		},
		{
			value: VehicleInsuranceCoverageTypeEnum.THIRD_PARTY,
			displayValue: 'vehicle-insurances|record-category|third-party',
			disabled: !FEATURES.vehicleInsurances,
		},
	];

export const VEHICLE_INSURANCE_PREMIUM_PERIODS: SelectItem<VehicleInsurancePremiumPeriodEnum>[] =
	[
		{
			value: VehicleInsurancePremiumPeriodEnum.MONTHLY,
			displayValue: 'vehicle-insurances|premium-period|monthly',
		},
		{
			value: VehicleInsurancePremiumPeriodEnum.YEARLY,
			displayValue: 'vehicle-insurances|premium-period|yearly',
		},
	];
